export interface MarketRowTextSource {
  question?: string | null;
  marketTitle?: string | null;
  eventTitle?: string | null;
}

export type MarketRowTitleField = keyof MarketRowTextSource;

export interface MarketRowText {
  title: string;
  subtext: string;
}

const norm = (value: string | null | undefined): string =>
  (value ?? "").replace(/\s+/g, " ").trim();

export const getMarketRowText = (
  market: MarketRowTextSource,
  titleOrder: readonly MarketRowTitleField[]
): MarketRowText => {
  const title =
    titleOrder.map((field) => norm(market[field])).find(Boolean) ?? "";
  const eventTitle = norm(market.eventTitle);
  const subtext =
    eventTitle && eventTitle.toLowerCase() !== title.toLowerCase()
      ? eventTitle
      : "";

  return { title, subtext };
};
